import React, { Component } from "react";
import Vacation from "../../../components/Vacation/Vacation";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : VacationForm
Description : Compoente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina – Se llama al componente de Vacation con sus respectivos parámetros.
================================================================================ */

class VacationForm extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <Vacation/>
        )
    }
}

export default VacationForm;